import React from "react";
import { Link } from "react-router-dom";
import ErrorPageImg from "../assets/paramarshLogo.png";

const ErrorPage = () => {
  return (
    <>
      <div className="error-page">
       
        <img src={ErrorPageImg} alt="Error 404" />
        <Link className="nav-link" aria-current="page" to="/">
          <button className="btn mt-10">Go Back To Home</button>
        </Link>
      </div>
    </>
  );
};

export default ErrorPage;
